'use client';
import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined';
import SellOutlined from '@mui/icons-material/SellOutlined';
import { formatDateFromISO } from '@practium/shared';
import ReactMarkdown from 'react-markdown';
import { Policy } from '../../types/policy.types';
import styles from './DocumentViewer.module.css';
import { DocumentViewerBase } from './DocumentViewerBase';

interface DocumentViewerProps {
	policy: Policy | null;
	isModal?: boolean;
}

export const DocumentViewer = ({ policy, isModal = false }: DocumentViewerProps) => {
	if (!policy) {
		return <DocumentViewerBase isEmpty={true} isModal={isModal} />;
	}

	return (
		<DocumentViewerBase isModal={isModal}>
			<div className={styles.statusHeader}>
				<span className={styles.statusBadge}>{policy.isActive ? 'ATIVO' : 'INATIVO'}</span>
				<span className={styles.lastEdited}>Última edição: {formatDateFromISO(policy.updatedAt)}</span>
			</div>

			<h1 className={styles.documentTitle}>{policy.title}</h1>
			<p className={styles.documentSubtitle}>{policy.description}</p>

			<div className={styles.metaInfo}>
				<div className={styles.metaItem}>
					<SellOutlined className={styles.metaIcon} />
					<span className={styles.metaLabel}>Versão</span>
					<span className={styles.metaValue}>{policy.versionNumber}</span>
				</div>
				<div className={styles.divider}></div>
				<div className={styles.metaItem}>
					<CalendarTodayOutlined className={styles.metaIcon} />
					<span className={styles.metaLabel}>Vigência</span>
					<span className={styles.metaValue}>
						{formatDateFromISO(policy.effectiveDate)}
					</span>
				</div>
			</div>

			<div className={styles.content}>
				<ReactMarkdown
					components={{
						h1: ({ children }) => <h2 className={styles.sectionTitle}>{children}</h2>,
						h2: ({ children }) => <h3 className={styles.sectionSubtitle}>{children}</h3>,
						p: ({ children }) => <p className={styles.paragraph}>{children}</p>,
						strong: ({ children }) => <strong className={styles.bold}>{children}</strong>,
						em: ({ children }) => <em className={styles.italic}>{children}</em>,
						ul: ({ children }) => <ul className={styles.list}>{children}</ul>,
						ol: ({ children }) => <ol className={styles.orderedList}>{children}</ol>,
						li: ({ children }) => <li className={styles.listItem}>{children}</li>,
					}}
				>
					{policy.content}
				</ReactMarkdown>
			</div>
		</DocumentViewerBase>
	);
};
